var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "jade-tooltip" }, [
    _c(
      "div",
      {
        ref: "referenceRef",
        staticClass: "jade-tooltip__trigger inline-block",
        attrs: {
          role: "presentation",
          "aria-describedby": _vm.defineFloatingID,
        },
        on: {
          blur: _vm.hide,
          focus: _vm.show,
          mouseenter: _vm.show,
          mouseleave: _vm.hide,
        },
      },
      [_vm._t("default")],
      2
    ),
    _c(
      "div",
      {
        ref: "floatingRef",
        class: ["absolute top-0 left-0 z-50", !_vm.isVisible && "hidden"],
        attrs: { role: "tooltip", tabindex: "-1", id: _vm.defineFloatingID },
      },
      [
        _c(
          "div",
          { staticClass: "jade-tooltip__container" },
          [
            _c("div", {
              ref: "arrowRef",
              staticClass:
                "absolute h-[8px] w-[8px] rotate-45 bg-jade-background-neutral",
              attrs: { "aria-hidden": "true" },
            }),
            _c(
              "jade-text",
              {
                attrs: {
                  variant: "text-small",
                  weight: "medium",
                  color: "on-brand",
                },
              },
              [_vm._v(" " + _vm._s(_vm.text) + " ")]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }